module.exports = __webpack_public_path__ + "static/img/item-7-1.df3fdf7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sustainable/innovation/item-7-1.jpg
// module id = AYFY
// module chunks = 2